var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { HttpLink } from '@apollo/client';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { createCandidateAuthStrategy } from '@seek/online-identity';
import { createBrowserLinkFetch } from './createBrowserLinkFetch.js';
import { getSeekHeaders } from './getSeekHeaders.js';
import getTrackingHeaders from './getTrackingHeaders.js';
export const browserHttpLink = (_a) => {
    var { appName, headers, graphqlEndpointOverride, batchRequests = false, batchRequestOptions = {}, authOptions, metricsHandler } = _a, seekHeaderOptions = __rest(_a, ["appName", "headers", "graphqlEndpointOverride", "batchRequests", "batchRequestOptions", "authOptions", "metricsHandler"]);
    const trackingHeaders = getTrackingHeaders();
    const seekHeaders = getSeekHeaders(seekHeaderOptions);
    let authStrategy = null;
    if (authOptions.useAuth) {
        authStrategy = createCandidateAuthStrategy({
            hostOverride: authOptions.hostOverride,
            mockOptions: authOptions.mockOptions,
            useMockedAuth: authOptions.useMockedAuth,
            forceStrategy: authOptions.forceStrategy,
        });
    }
    const config = {
        uri: graphqlEndpointOverride !== null && graphqlEndpointOverride !== void 0 ? graphqlEndpointOverride : '/graphql',
        fetch: createBrowserLinkFetch(authStrategy, appName, trackingHeaders, seekHeaders, headers !== null && headers !== void 0 ? headers : {}, metricsHandler),
    };
    return batchRequests
        ? new BatchHttpLink(Object.assign(Object.assign({}, config), batchRequestOptions))
        : new HttpLink(config);
};
//# sourceMappingURL=browser-http-link.js.map